import { useInfiniteQuery } from '@tanstack/react-query';
import { NotificationApiV2 } from 'Data/Notification.api.v2';
import { NOTIFICATIONS_QUERY_KEY } from 'Data/keys/QueryKeys';

export const useQueryNewNotifications = (
  constructionSiteId: number | null,
  personalKey: 'NOTIFICATIONS_PERSONAL_KEY' | null,
  pageInfinityNotificationsSize: number = 10,
) => {
  const {
    data,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    isLoading,
    error,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: (constructionSiteId || personalKey)
      ? [NOTIFICATIONS_QUERY_KEY, (constructionSiteId ? Number(constructionSiteId) : personalKey)]
      : [NOTIFICATIONS_QUERY_KEY],
    initialPageParam: 1,
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async ({ pageParam }) => {
      const response = await NotificationApiV2.listNewNotifications({
        constructionSiteId,
        personalOnly: !!personalKey ? true : false,
        pageNumber: pageParam,
        pageSize: pageInfinityNotificationsSize,
      });
      return { notifications: response.data.data, info: response.data.info };
    },
    getNextPageParam: (last) => {
      return last.info?.nextPageNumber ? last.info.nextPageNumber : undefined;
    },
  });

  return {
    data: data?.pages.flatMap((page) => page.notifications) ?? [],
    isLoading,
    isRefetching,
    error,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    fetchNextPage,
  };
};
